/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import { Dialog, DialogActions, Button, DialogContent, DialogContentText, Slide } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { AGENT_STATUS_ALERTS } from "../../../../utility/constants";
import { StatusAlertsProvider, useStatusAlerts } from "../../../dispositionManager/context/statusAlerts";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * This component takes in the current status of the agent and sets a list timeouts
 * to display notification to an agent depending on their status.
 * When a timeout in this list expires a pre-configured message will display.
 * @param {Object} status The current status of the agent.
 */
const StatusAlertContent = ({ status = { name: "Available" } }) => {
	const [message, setMessage] = useState("");
	const { statusAlerts, getStatusAlertsList } = useStatusAlerts();
	//eslint-disable-next-line no-unused-vars
	const [timeOuts, setTimeouts] = useState([]);
	useEffect(() => {
		const fetchData = async () => {
			await getStatusAlertsList();
		};
		fetchData();
	}, [getStatusAlertsList]);

	useEffect(() => {
		const currentStatusAlert = statusAlerts.find((st) => st.statusName === status.name && st.active);
		const alerts = currentStatusAlert?.alerts || [];
		setTimeouts((oldTimeouts) => {
			oldTimeouts.forEach((oldTimeout) => clearTimeout(oldTimeout));
			return alerts.map((alert) =>
				setTimeout(() => {
					setMessage(alert.message);
				}, alert.time * AGENT_STATUS_ALERTS.ALERT_TIME_UNITS),
			);
		});
	}, [statusAlerts, status]);

	return (
		<Dialog open={!!message} TransitionComponent={Transition} aria-describedby="alert-dialog-slide-description">
			<DialogContent style={{ minWidth: 400 }}>
				<DialogContentText id="alert-dialog-slide-description" style={{ color: "black" }}>
					{message}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button variant={"outlined"} onClick={() => setMessage("")}>
					OK
				</Button>
			</DialogActions>
		</Dialog>
	);
};

const StatusAlert = (props) => (
	<StatusAlertsProvider>
		<StatusAlertContent {...props} />
	</StatusAlertsProvider>
);

export default StatusAlert;
